import { useRBACPermissions } from '@/contexts/useRBACPermissions'

export function useCanRenameOrganization(): boolean {
  const { hasAdminRights, hasOperatorRights } = useRBACPermissions()
  return hasAdminRights() || hasOperatorRights()
}
